import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommissioningStore, DeviceAssignmentResult } from '@store';
import { filter, take } from 'rxjs/operators';
import { ModalAction } from '../commissioning.model';
import { CommissioningService } from '../commissioning.service';

@Component({
  selector: 'app-commissioning-assignment-loader-modal',
  templateUrl: './commissioning-assignment-loader-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommissioningAssignmentLoaderModalComponent implements OnInit {
  constructor(
    private commissioningService: CommissioningService,
    private commissioningStore: CommissioningStore,
    private dialogRef: MatDialogRef<CommissioningAssignmentLoaderModalComponent>
  ) {}

  ngOnInit(): void {
    this.dialogRef.updateSize('768px');
    this.dialogRef.addPanelClass('commissioning-modal');
    this.commissioningStore.deviceAssignAttempt();

    this.commissioningStore.assignmentResult$
      .pipe(
        filter((entry) => !!entry),
        take(1)
      )
      .subscribe((result) => {
        if (result === DeviceAssignmentResult.Success) {
          this.commissioningService.modalAction$.next(ModalAction.NextStep);
        } else {
          this.commissioningService.modalAction$.next(ModalAction.NavigateToFinalStep);
        }
      });
  }
}
